import {
    AuthenticationContextProvider,
    UserContextProvider,
    ContentContextProvider,
    PanelContextProvider,
    GameContextProvider,
    BookContextProvider,
    MovieContextProvider,
    UiContextProvider,
    LayerContextProvider,
    WhereIsThisContextProvider
} from "../contexts"
import { FreeSpaceAreaContextProvider } from "./FreeSpaceAreaContext";

export const RootContextProvider = (props) => {

    return (
        <AuthenticationContextProvider>
            <UserContextProvider>
                <ContentContextProvider>
                    <PanelContextProvider>
                        <GameContextProvider>
                            <BookContextProvider>
                                <MovieContextProvider>
                                    <UiContextProvider>
                                        <LayerContextProvider>
                                            <WhereIsThisContextProvider>
                                                <FreeSpaceAreaContextProvider>
                                                    {props.children}
                                                </FreeSpaceAreaContextProvider>
                                            </WhereIsThisContextProvider>
                                        </LayerContextProvider>
                                    </UiContextProvider>
                                </MovieContextProvider>
                            </BookContextProvider>
                        </GameContextProvider>
                    </PanelContextProvider>
                </ContentContextProvider>
            </UserContextProvider>
        </AuthenticationContextProvider>
    );
}

export default RootContextProvider;